import { FilterIcon } from "assets/icons";
import cn from "classnames";
import { useBoolean, useOnClickOutside } from "hooks";
import { useRef } from "react";
import { Button } from "ui";

import { TableFilterProps } from "./TableFilter.types";

import styles from "./TableFilter.module.scss";

const TableFilter = ({ children }: TableFilterProps) => {
  const {
    value: isFilterOpen,
    toggle: toggleFilter,
    setFalse: closeFilter
  } = useBoolean(false);

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, closeFilter);

  return (
    <div className={styles.tableFilter} ref={containerRef}>
      <Button
        variant={"primary"}
        icon={<FilterIcon />}
        className={styles.tableFilter_button}
        onClick={toggleFilter}
      />

      <div
        className={cn([
          styles.tableFilter_content,
          { [styles.tableFilter_content__open]: isFilterOpen }
        ])}
      >
        {children({ closeFilter })}
      </div>
    </div>
  );
};

export default TableFilter;
